export type DynamicTableColumnType = 'text' | 'number' | 'date' | 'time' | 'signature' | 'row_number'

export interface DynamicTableColumn {
    /** Estável mesmo se a coluna for reordenada/renomeada depois de já existirem linhas preenchidas. */
    id: string
    label: string
    type: DynamicTableColumnType
}

export interface DynamicTableData {
    columns: DynamicTableColumn[]
    /** Só afeta o botão "+ adicionar linha" no link público — nunca a assinatura (sempre restrita à equipe logada). */
    allowPublicAddRow: boolean
}

export type DynamicTableRowStatus = 'pending' | 'signed'

export interface DynamicTableSignatureMeta {
    /** URL definitiva no S3. */
    imageUrl: string
    /** ISO, carimbado pelo servidor. */
    signedAt: string
    ipAddress: string | null
    userAgent: string | null
    signedVia: 'remote_link' | 'in_person'
}

export type DynamicTableCellValue = string | DynamicTableSignatureMeta | null

export interface DynamicTableRow {
    /** uuid gerado pelo servidor ao adicionar a linha. */
    id: string
    /** ISO, carimbado pelo servidor ao adicionar a linha. */
    createdAt: string
    status: DynamicTableRowStatus
    active?: boolean
    /** chave = DynamicTableColumn.id */
    cells: Record<string, DynamicTableCellValue>
}

export interface DynamicTableValue {
    rows: DynamicTableRow[]
}

export function createDefaultDynamicTableData(): DynamicTableData {
    return {
        columns: [
            { id: crypto.randomUUID(), label: 'Data', type: 'date' },
            { id: crypto.randomUUID(), label: 'Assinatura', type: 'signature' },
        ],
        allowPublicAddRow: false,
    }
}

export function createDefaultDynamicTableValue(): DynamicTableValue {
    return { rows: [] }
}

export function isDynamicTableValueEmpty(value: DynamicTableValue | null | undefined): boolean {
    return !value?.rows?.length
}

/** A linha inteira trava assim que qualquer coluna de assinatura for assinada. */
export function isRowLocked(row: DynamicTableRow): boolean {
    return row.status === 'signed'
}

/** `undefined` (linhas salvas antes desse campo existir) conta como ativa. */
export function isRowActive(row: DynamicTableRow): boolean {
    return row.active !== false
}

export function isSignatureMeta(value: DynamicTableCellValue): value is DynamicTableSignatureMeta {
    return typeof value === 'object' && value !== null
}

export function computeRowNumbers(rows: DynamicTableRow[]): (number | null)[] {
    let counter = 0
    return rows.map((row) => {
        if (!isRowActive(row)) return null
        counter += 1
        return counter
    })
}
